






































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({})
export default class ConfirmFeedback extends Vue {
  @Prop() show: boolean;
  @Prop() confirmType: string;
  @Prop() successStatu: boolean;
  @Prop() errorMsg: string;
  showFeedDialog: boolean = false;
  currentConfirmType: string = '';
  currentErrorMsg: string = '';
  currentSuccessStatu: boolean = false;
  containerStyle: any = {
    backgroundImage: 'url(' + require('@/images/提交成功通用背景.png') + ')',
    backgroundRepeat: 'round',
    backgroundSize: '100%',
  };
  feedSuccessStyle: any = {
    backgroundImage: 'url(' + require('@/images/提交成功通用状态.png') + ')',
    backgroundRepeat: 'round',
    backgroundSize: '100%',
    height: '45%',
    width: '45%',
  };
  feedFailStyle: any = {
    backgroundImage: 'url(' + require('@/images/提交失败通用状态.png') + ')',
    backgroundRepeat: 'round',
    backgroundSize: '100%',
    height: '45%',
    width: '45%',
  };
  @Watch('show')
  async onShow(val: boolean) {
    this.showFeedDialog = val;
    if (val) {
      setTimeout(() => {
        this.showFeedDialog = false;
      }, 3000);
    }
  }
  @Watch('confirmType')
  async onConfirmType(val: string) {
    if (val) {
      this.currentConfirmType = val;
    }
  }
  @Watch('successStatu')
  async onConfirmSuccessStatu(val: boolean) {
    this.currentSuccessStatu = val;
  }

  @Watch('errorMsg')
  async onErrorMsg(val: string) {
    if (val) {
      this.currentErrorMsg = val;
    }
  }

  onCancel() {
    this.$emit('feedbaclCancle');
  }
}
